import React from 'react';

/**
 * Inline SVG logo — king piece + "ChessFlashcards.org" in Josefin Sans.
 * variant="white" → wK piece (white fill, black outline) + white text  (for dark backgrounds)
 * variant="black" → bK piece (black fill, light lines)  + black text  (for light backgrounds)
 */
export default function Logo({ variant = 'white', height = 54 }) {
  const isWhite = variant === 'white';
  const textColor   = isWhite ? '#ffffff' : '#000000';
  const aspectRatio = 444 / 54;
  const width       = Math.round(height * aspectRatio);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 444 54"
      width={width}
      height={height}
      aria-label="ChessFlashcards.org"
      role="img"
    >
      {/* King piece — scaled from 45×45 viewBox to 50×50, bottom-aligned */}
      <g transform="translate(4,2) scale(1.111111)">
        {isWhite ? (
          /* wK: white body, black outlines */
          <g fill="none" fillRule="evenodd" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
            <path strokeLinejoin="miter" d="M22.5 11.63V6M20 8h5"/>
            <path fill="#fff" strokeLinecap="butt" strokeLinejoin="miter"
              d="M22.5 25s4.5-7.5 3-10.5c0 0-1-2.5-3-2.5s-3 2.5-3 2.5c-1.5 3 3 10.5 3 10.5"/>
            <path fill="#fff"
              d="M11.5 37c5.5 3.5 15.5 3.5 21 0v-7s9-4.5 6-10.5c-4-6.5-13.5-3.5-16 4V27v-3.5c-3.5-7.5-13-10.5-16-4-3 6 5 10 5 10z"/>
            <path d="M11.5 30c5.5-3 15.5-3 21 0m-21 3.5c5.5-3 15.5-3 21 0m-21 3.5c5.5-3 15.5-3 21 0"/>
          </g>
        ) : (
          /* bK: black body, light interior lines */
          <g fill="none" fillRule="evenodd" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
            <path strokeLinejoin="miter" d="M22.5 11.6V6"/>
            <path fill="#000" strokeLinecap="butt" strokeLinejoin="miter"
              d="M22.5 25s4.5-7.5 3-10.5c0 0-1-2.5-3-2.5s-3 2.5-3 2.5c-1.5 3 3 10.5 3 10.5"/>
            <path fill="#000"
              d="M11.5 37a22.3 22.3 0 0 0 21 0v-7s9-4.5 6-10.5c-4-6.5-13.5-3.5-16 4V27v-3.5c-3.5-7.5-13-10.5-16-4-3 6 5 10 5 10z"/>
            <path strokeLinejoin="miter" d="M20 8h5"/>
            <path stroke="#ececec"
              d="M32 29.5s8.5-4 6-9.7C34.1 14 25 18 22.5 24.6v2.1-2.1C20 18 9.9 14 7 19.9c-2.5 5.6 4.8 9 4.8 9"/>
            <path stroke="#ececec"
              d="M11.5 30c5.5-3 15.5-3 21 0m-21 3.5c5.5-3 15.5-3 21 0m-21 3.5c5.5-3 15.5-3 21 0"/>
          </g>
        )}
      </g>

      {/* Logotype */}
      <text
        x="56"
        y="44.6"
        fontFamily="'Josefin Sans', sans-serif"
        fontWeight="700"
        fontSize="35"
        fill={textColor}
        letterSpacing="0.35"
      >
        ChessFlashcards.org
      </text>
    </svg>
  );
}
